import { ApiError } from './api-error';

export function toastErrorOptionsFor(error: unknown): { reportError: false } | undefined {
  if (error instanceof ApiError && error.userError) {
    return { reportError: false };
  }
  return undefined;
}
